/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Kind_ExpenseInputs */

const vi_expense_kind_expense = /** @type {(inputs: Expense_Kind_ExpenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Chi`)
};

/**

* @param {Expense_Kind_ExpenseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_kind_expense = /** @type {((inputs?: Expense_Kind_ExpenseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Kind_ExpenseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_kind_expense(inputs)
});